import * as React from "react";
type Props = {
  className?: string,
};
function SvgMap({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Map"
      className={className}
    >
      <path
        d="M18.808 7.40394C19.1781 7.5889 19.5862 7.68518 20 7.68518C20.4138 7.68518 20.8219 7.5889 21.192 7.40394L26.0707 4.96394C26.2741 4.86229 26.5002 4.81435 26.7273 4.8247C26.9545 4.83504 27.1753 4.90332 27.3686 5.02305C27.562 5.14277 27.7215 5.30996 27.832 5.50872C27.9425 5.70747 28.0003 5.93119 28 6.15861V23.1773C27.9999 23.4248 27.9308 23.6674 27.8006 23.878C27.6704 24.0885 27.4841 24.2586 27.2627 24.3693L21.192 27.4053C20.8219 27.5902 20.4138 27.6865 20 27.6865C19.5862 27.6865 19.1781 27.5902 18.808 27.4053L13.192 24.5973C12.8219 24.4123 12.4138 24.316 12 24.316C11.5862 24.316 11.1781 24.4123 10.808 24.5973L5.92934 27.0373C5.72581 27.139 5.49963 27.1869 5.27235 27.1765C5.04506 27.1661 4.82421 27.0977 4.63083 26.9778C4.43744 26.8579 4.27795 26.6906 4.16753 26.4916C4.05711 26.2927 3.99944 26.0688 4 25.8413V8.82394C4.00014 8.57639 4.06918 8.33377 4.19941 8.12324C4.32963 7.91271 4.5159 7.74259 4.73734 7.63194L10.808 4.59594C11.1781 4.41098 11.5862 4.3147 12 4.3147C12.4138 4.3147 12.8219 4.41098 13.192 4.59594L18.808 7.40394Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 7.6853V27.6853"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 4.3147V24.3147"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgMap;
